
export enum EventBookingStrategy {
  GenericSelling = 'GenericSelling',
  TicketsAndProducts = 'TicketsAndProducts',
  Tickets = 'Tickets',
  Vouchers = 'Vouchers',
  Calendar = 'Calendar',
  TicketAsPass = 'TicketAsPass',
}
